export enum RegionCustomEnum {
  EUROPE = "EUROPE",
  OCEANIA = "OCEANIA",
  NORTHAMERICA = "NORTHAMERICA",
  SOUTHAMERICA = "SOUTHAMERICA",
  AFRICA = "AFRICA",
  EUROPEANUNION = "EUROPEANUNION",
  ASIA = "ASIA",
  OTHER = "OTHER",
  DOMTOM = "DOMTOM",
}
